import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "long-arrow-up-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.5304 0.969182C12.2375 0.676288 11.7626 0.676288 11.4697 0.969182L6.46869 5.97018C6.1758 6.26307 6.1758 6.73795 6.46869 7.03084C6.76159 7.32373 7.23646 7.32373 7.52935 7.03084L11.25 3.3102V22.5005C11.25 22.9147 11.5858 23.2505 12 23.2505C12.4142 23.2505 12.75 22.9147 12.75 22.5005V3.31015L16.4707 7.03084C16.7636 7.32373 17.2385 7.32373 17.5314 7.03084C17.8242 6.73795 17.8242 6.26307 17.5314 5.97018L12.5304 0.969182Z" }, null, -1)
  ])))
}
export default { render: render }